import request from './axios';

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.name 姓名
 * @param {String} data.email 邮箱
 * @param {String} data.phone 电话
 * @param {String} data.subject 主题
 * @param {String} data.message 留言内容
 * @returns {Promise<Object>} 返回提交结果
 */
export function submitContact(data) {
  return request({
    url: '/no-auth/feedback/create',
    method: 'post',
    data
  });
}


export default {
  submitContact
}; 